import {
  ProfileType,
  Subscription as JSUserSubscription,
  User as JsUser,
  UserProfile,
  Organization as JsOrganization,
  BillingInfo as JsBillingInfo,
  Status as JsStatus,
  CardInfo as JsCardInfo,
  NextPaymentInfo as JsNextPaymentInfo,
  Coupon as JSCoupon,
} from "@blacknut/javascript-sdk/dist";

export const MAX_FAMILY_PROFILES = 5;

/** @deprecated */
export declare type CardInfo = JsCardInfo;

/** @deprecated */
export declare type NextPaymentInfo = JsNextPaymentInfo;
/** @deprecated */
export declare type Coupon = JSCoupon;

/** @deprecated */
export enum Status {
  ACTIVE = "active",
  CANCELED = "canceled",
  PAST_DUE = "past_due",
  TRIALING = "trialing",
  INCOMPLETE = "incomplete",
  SUSPENDED = "suspended",
  CANCELING = "canceling",
}
export enum UserSubscriptionKind {
  STRIPE = "stripe",
  GOOGLE_PLAY = "google_play",
  AMAZON = "amazon",
  SAMSUNG_IAP = "samsungiap",
  PARTNER = "partner",
  POST = "post",
  AIS = "ais",
  A1 = "a1",
  SWISSCOM = "swisscom",
  DREI = "drei",
  CELCOM = "celcom",
  M1 = "m1",
}
/** @deprecated */
export declare type UserSubscription = JSUserSubscription;

/** @deprecated */
export declare type Organization = JsOrganization;

/** @deprecated */
export declare type User = JsUser;

/** @deprecated */
export declare type FamilyProfile = UserProfile;

export interface ProfilePref {
  theme: string;
  acknowledgedGamepadGames?: Set<string>;
}

export const isKidProfile = (u: ProfileType) => {
  return u !== ProfileType.GENERIC;
};

export const userHasPlan = (u: User, subscription?: UserSubscription) => {
  if (u.betaStatus === "active") {
    return true;
  }
  return !!subscription && subscription!.status !== JsStatus.INCOMPLETE;
};

/** @deprecated */
export const isValidSubscription = (u: User, billingInfo: BillingInfo) => {
  if (u.betaStatus === "active") {
    return true;
  }
  const subscriptionValid =
    billingInfo.subscription &&
    (billingInfo.subscription.status === JsStatus.ACTIVE ||
      billingInfo.subscription.status === JsStatus.CANCELING ||
      billingInfo.subscription.status === JsStatus.TRIALING);
  return subscriptionValid /*&& !billingInfo.subscription?.plan.default FIXME REMOVE*/;
};

export const isDefaultPlan = (billingInfo: BillingInfo) => {
  return billingInfo.subscription && billingInfo.subscription.plan.default;
};

/**@deprecated */
export declare type BillingInfo = JsBillingInfo;

export const getAisReceiptUri = (user: User) => {
  return `https://wapshop.gameloft.com/aisgamecloud/receipt.php?pid=${encodeURIComponent(
    user.partnerId as string,
  )}`;
};
